import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import useAuthStore from './store/authStore';

// Pages
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Updates from './pages/Updates';
import Digest from './pages/Digest';
import Profile from './pages/Profile';
import AdminPanel from './pages/AdminPanel';
import ComplianceTracker from './pages/ComplianceTracker';
import AnalyticsDashboard from './pages/AnalyticsDashboard';

// Components
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';
import Navbar from './components/Navbar';
import ErrorBoundary from './components/ErrorBoundary';

function App() {
  const { isAuthenticated, checkAuth } = useAuthStore();

  useEffect(() => {
    checkAuth();
  }, []);

  return (
    <>
      <Toaster position="top-right" />
      <BrowserRouter>
        {isAuthenticated && <Navbar />}
        <ErrorBoundary>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />

            <Route element={<PrivateRoute />}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/updates" element={<Updates />} />
              <Route path="/digest" element={<Digest />} />
              <Route path="/compliance" element={<ComplianceTracker />} />
              <Route path="/analytics" element={<AnalyticsDashboard />} />
              <Route path="/profile" element={<Profile />} />
            </Route>

            <Route element={<AdminRoute />}>
              <Route path="/admin" element={<AdminPanel />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </ErrorBoundary>
      </BrowserRouter>
    </>
  );
}

export default App;
